var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90224 5.61123H3.31037L5.76754 3.15406C6.02952 2.89208 6.02952 2.45846 5.76754 2.19648C5.50557 1.93451 5.07195 1.93451 4.80997 2.19648L1.19648 5.80997C0.934506 6.07195 0.934506 6.50557 1.19648 6.76754L4.80997 10.381C4.94547 10.5165 5.11712 10.5798 5.28876 10.5798C5.4604 10.5798 5.63204 10.5165 5.76754 10.381C6.02952 10.1191 6.02952 9.68543 5.76754 9.42346L3.31037 6.96629H8.90224C11.522 6.96629 13.6449 9.09824 13.6449 11.709V13.5157C13.6449 13.8861 13.9521 14.1933 14.3225 14.1933C14.6929 14.1933 15 13.8861 15 13.5157V11.709C15 8.34844 12.2628 5.61123 8.90224 5.61123Z",
    fill: "#5A4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.43281481d14a918b53b098e6fe9c358a.svg";
export { ForwardRef as ReactComponent };